import type { Resource } from '../../';
export const order_orderSummary_shipping: Resource = {"default":"Shipping"};
